import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface UserFeature {
  feature_key: string;
  feature_name: string;
  description: string;
  enabled: boolean;
  is_default: boolean;
  enabled_at: string | null;
  disabled_at: string | null;
  notes: string | null;
}

export function useUserFeatures(userId: string) {
  return useQuery({
    queryKey: ['user-features', userId],
    queryFn: () => apiClient<UserFeature[]>(`/user-features/${userId}`),
  });
}

interface ToggleFeatureInput {
  featureKey: string;
  enabled: boolean;
  notes?: string;
}

export function useToggleUserFeature(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ featureKey, enabled, notes }: ToggleFeatureInput) =>
      apiClient<{ success: boolean; message: string; feature: UserFeature | null }>(
        `/user-features/${userId}/${featureKey}`,
        { method: 'PUT', body: JSON.stringify({ enabled, notes }) }
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['user-features', userId] }),
  });
}
